module.exports = __webpack_public_path__ + "static/img/mkleo.14afbd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/mkleo.jpg
// module id = 7Snm
// module chunks = 35